export default {
  tool: {
    playable: {
      template: 'Playable Template Feature Project',
      editor: 'Playable Content Editing Project',
    },
    video: {
      editor: 'Video Projects',
    },
    screen: {
      recording: 'Screen Recording Projects',
    },
    customized: {
      creative: 'Creative Service',
    },
  },
}
